import { useContactList } from "@/api/services/admin/contact";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { ContactListTop } from "@/features/contact/components/ContactListTop";
import { ContactTable } from "@/features/contact/components/ContactTable";

import { Stack } from "@mui/material";
import { FC } from "react";

type TResolvedContactListPageProps = {};

export const ResolvedContactListPage: FC<TResolvedContactListPageProps> = () => {
  const { data: contactListResult, isLoading } = useContactList([true]);

  if (isLoading) return <LoadingPage />;
  return (
    <Stack gap={3}>
      <ContactListTop totalPage={contactListResult?.pagination.totalPage} />
      {contactListResult && <ContactTable isResolved={true} isLoading={isLoading} data={contactListResult ?? []} />}
    </Stack>
  );
};
